<script lang="ts">
	import MediaQuery from "svelte-media-query";
	import Button from "./Button.svelte";
	import {ASSET_URL} from "../config";
	import { _ } from '../services/i18n';


	export let nextStep: () => void;

	export let isSubmit = false;
</script>

<div class="next-button-container">
	<div class="next-button" class:submit-button={isSubmit}
		 style="{isSubmit ? '--focus-color: var(--focus-submit-color)' : ''}">
		{#if isSubmit}
			<Button type="submit" key="Enter" on:click={nextStep} background="#DE1125" borderColor="#DE1125" color="white">
				<svelte:fragment slot="start">
					<MediaQuery query="(max-width: 900px)" let:matches>
						{#if matches}
							&nbsp;
						{:else}
							Enter
						{/if}
					</MediaQuery>
				</svelte:fragment>
				{$_('submitBtn')}
				<img alt="" class="next-button-icon" src="{ASSET_URL}/assets/arrow-forward-white.svg">
			</Button>
		{:else}
			<Button key="Enter" on:click={nextStep}>
				<svelte:fragment slot="start">
					<MediaQuery query="(max-width: 900px)" let:matches>
						{#if matches}
							&nbsp;
						{:else}
							Enter
						{/if}
					</MediaQuery>
				</svelte:fragment>
				{$_('nextBtn')}
				<img alt="" class="next-button-icon" src="{ASSET_URL}/assets/arrow-forward.svg">
			</Button>
		{/if}
	</div>
</div>

<style>
	.next-button-icon {
		margin-bottom: 0 !important;
		margin-left: 10px;
		margin-right: 5px;
	}
	.next-button-container {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: end;
	}
	.next-button {
		display: flex;
		justify-content: end;
		transform: translateX(100px);
	}
</style>
